export const baseUrl = process.env.REACT_APP_BASE_URL || "/api/";
// export const baseUrl = "/api/";
export const loginUrl = baseUrl + "auth/login";
export const postData = baseUrl + "postData";
export const postManualData = baseUrl + "postManualData";
export const postNmsData = baseUrl + "postNmsData";
export const aerodromePostData = baseUrl + "aerodrome";
export const aerodromeDeleteData = baseUrl + "aerodrome-delete";
export const fetchMap = baseUrl + "get-map";
export const emails = baseUrl + "emails";
export const aerodromeUrl = baseUrl + "aerodrome";
export const appConstUrl = baseUrl + "app-const";
export const appConstPostData = `${appConstUrl}/add`;
export const aerodromeSearchUrl = baseUrl + "aerodrome-search";
export const usersUrl = baseUrl + "user";
// export const notamUrl = baseUrl + "notam";
export const userPostData = `${usersUrl}/add`;
export const userDeleteData = `${usersUrl}/delete`;
export const gmailData = `${baseUrl}/gmail-data`;
export const notamDelete = `${baseUrl}/notam-delete`;
export const signupUrl = baseUrl + "auth/signup";
export const countryAutoComplete = baseUrl + "countries";
export const verifyIdentity = baseUrl + "auth/identity";
export const profileInfo = baseUrl + "auth/profile";
export const profileUpdate = baseUrl + "auth/profile";
export const updateStaus = baseUrl + "auth/update-role-status";
export const userGetData = `${usersUrl}`;
export const forgotPasswordUrl = baseUrl + "auth/forget-password";
export const resetPasswordUrl = baseUrl + "auth/reset-password";
export const nmsLocations = baseUrl + "nms/locations";
export const nmsSync = baseUrl + "nms/sync";
export const nmsNotams = baseUrl + "nms/notams";
